import { render, staticRenderFns } from "./Aplicacao.vue?vue&type=template&id=f7003dd0&"
import script from "./Aplicacao.vue?vue&type=script&lang=js&"
export * from "./Aplicacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports